import { queryAll, query, fromId } from '../utils/utils.js';
//adapted from https://www.advancedcustomfields.com/resources/google-map/

export class Article {
    root = query('body');

    constructor() {
        console.log('[bhs] : article');

        this.groupOrphanedContent();
    }

    groupOrphanedContent() {

        const container = query('.container.article-page') || query('.single-services');
        const entryContent = container.querySelector('.entry-content');

        let currentGroup = null;

        for (const node of entryContent.childNodes) {
            if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.tagName.toLowerCase() === 'section') {
                    // Skip existing sections
                    currentGroup = null;
                } else {
                    if (!currentGroup) {
                        // Create a new section for grouping
                        currentGroup = document.createElement('section');
                        currentGroup.classList.add('grouped-section');

                        // Insert the new section before the current node
                        entryContent.insertBefore(currentGroup, node);
                    }

                    // Move the current node into the current group
                    currentGroup.appendChild(node);
                }
            }
        }

        // repeat for the containe after entry content was grouped
        for (const node of container.childNodes) {
            if (node.nodeType === Node.ELEMENT_NODE) {
                if(node.classList.contains('entry-content') || node.tagName.toLowerCase() === 'section') {
                    // Skip existing sections
                    currentGroup = null;
                } else {
                    if (!currentGroup) {
                        // Create a new section for grouping
                        currentGroup = document.createElement('section');
                        currentGroup.classList.add('grouped-section');

                        // Insert the new section before the current node
                        container.insertBefore(currentGroup, node);
                    }

                    // Move the current node into the current group
                    currentGroup.appendChild(node);
                }
            }
        }

    }

}
